import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { api, Button } from "@tc/ui";
const uk = (d) => `${d.slice(8, 10)}/${d.slice(5, 7)}/${d.slice(2, 4)}`;
/**
 * What's new: new release notes pop up once when someone opens Nozl; "What's new" in the menu shows the last few months.
 * Pass `all` to open the full list (from the menu).
 */
export function WhatsNew({ open, onClose, navigate }) {
    const [notes, setNotes] = useState(null);
    useEffect(() => {
        if (!open) {
            setNotes(null);
            return;
        }
        void api(`/api/whats-new${open === "all" ? "?all=1" : ""}`).then((d) => { if (open === "new" && !d.notes.length)
            onClose();
        else
            setNotes(d.notes); }, () => onClose());
    }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
    if (!open || !notes)
        return null;
    const done = async () => {
        const top = Math.max(0, ...notes.map((n) => n.id));
        if (top)
            await api("/api/whats-new/seen", { body: { upTo: top } }).catch(() => undefined);
        onClose();
    };
    return (_jsx("div", { className: "tc-store-overlay tc-rep-overlay", role: "dialog", "aria-modal": "true", "aria-label": "What's new", onClick: () => void done(), children: _jsxs("div", { className: "tc-aud-sheet tc-wn", onClick: (e) => e.stopPropagation(), children: [_jsxs("div", { className: "tc-aud-sheet-h", children: [_jsx("b", { children: "What's new in Nozl" }), _jsx("button", { className: "tc-rep-x", "aria-label": "Close", onClick: () => void done(), children: "\u00D7" })] }), _jsxs("div", { className: "tc-aud-sheet-b", children: [!notes.length && _jsx("p", { className: "muted", children: "Nothing new in the last few months." }), notes.map((n) => (_jsxs("article", { className: "tc-wn-note", children: [_jsx("small", { className: "muted", children: uk(n.published_on) }), _jsx("h3", { children: n.title }), n.body && n.body.split(/\n{2,}/).map((p, i) => _jsx("p", { children: p }, i)), n.link && _jsx(Button, { onClick: () => { void done(); navigate(n.link); }, children: "Show me" })] }, n.id)))] }), _jsx("div", { className: "tc-aud-sheet-f", children: _jsx(Button, { primary: true, onClick: () => void done(), children: "Got it" }) })] }) }));
}
